module.exports = __webpack_public_path__ + "media/images/photo/top/album/album5-9cefc2d01b7c6baade674ac302101db6.jpg";